<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">Create / Update Organization Token</legend>
    </div>
    <div class="grid-col flex-auto margin-left-2">
      <ul class="usa-nav__primary usa-accordion">
        <li class="usa-nav__primary-item">
          <button class="usa-accordion__button define-eclipse" aria-expanded="false" aria-controls="more-actions"
                  data-tooltip="Click for more options">
            <span>&hellip;</span>
          </button>
          <ul id="more-actions" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a routerLink="" (click)="gotToAgencyProfile()">Agency Profile</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <form [formGroup]="generateAPIFormGroup">
    <fieldset class="usa-fieldset">
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <div class="grid-row grid-gap-0">
            <legend class="usa-legend usa-legend--medium">API</legend>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label"> API Type <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="apiType" formControlName="apiType" class="usa-select" title="apiType" name="apiType">
                <option [value]='null' selected disabled>Choose...</option>
                <option *ngFor='let c of rateQueryTypes' [value]="c">{{c}}</option>
              </select>
              <small class="define-text-secondary" *ngIf="(generateAPIFormGroup.get('apiType').touched ||
                                                            generateAPIFormGroup.get('apiType').dirty) &&
                                                            generateAPIFormGroup.get('apiType').errors?.required">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> API Type is required.
              </small>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label"> API Status <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="apiStatus" formControlName="apiStatus" class="usa-select" title="apiStatus" name="apiStatus">
                <option [value]='null' selected disabled>Choose...</option>
                <option *ngFor='let c of apiStatus' [value]="c">{{c}}</option>
              </select>
              <small class="define-text-secondary" *ngIf="(generateAPIFormGroup.get('apiStatus').touched ||
                                                            generateAPIFormGroup.get('apiStatus').dirty) &&
                                                            generateAPIFormGroup.get('apiStatus').errors?.required">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> API Status is required.
              </small>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label"> Agency Token <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" class="usa-input" id="agencyToken" formControlName="agencyToken" readonly/>
              <small class="define-text-secondary"*ngIf="(generateAPIFormGroup.get('agencyToken').touched ||
                                                          generateAPIFormGroup.get('agencyToken').dirty) &&
                                                          generateAPIFormGroup.get('agencyToken').errors?.required">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Token is required.
              </small>
              <div>
                <ul class="usa-button-group">
                  <li class="usa-button-group__item">
                     <button (click)="generateAPI()" class="usa-button margin-top-105">Generate Token</button>
                  </li>
                  <li class="usa-button-group__item">
                    <button type="button" class="usa-button margin-top-105" (click)="viewAuditTrial()">View Audit Trail</button>
                  </li>
                </ul>
               
              </div>
            </div>
          </div>

        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <div class="grid-row grid-gap-0">
            <legend class="usa-legend usa-legend--medium">Dates</legend>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="effectiveDate" class="usa-label">Effective Date</label>
              <input type="text" id="effectiveDate" formControlName="effectiveDate" class="usa-input"
                     [value]="this.defaultDate" bsDatepicker [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"/>
              <small class="define-text-secondary" *ngIf="isFieldValid('effectiveDate')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Please select an effective date.
              </small>
              <small class="define-text-secondary" *ngIf="generateAPIFormGroup.hasError('notValid')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Please adjust expiry date to ensure it is before expiry Date.
              </small>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="expiryDate" class="usa-label">Expiry Date</label>
              <input type="text" id="expiryDate" formControlName="expiryDate" class="usa-input" [value]="this.defaultDate"
                     bsDatepicker [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"/>
              <small class="define-text-secondary" *ngIf="isFieldValid('expiryDate')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Please select a expiry date.
              </small>
              <small class="define-text-secondary" *ngIf="generateAPIFormGroup.hasError('notValid')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Please adjust expiry date to ensure it is after effective Date.
              </small>
            </div>
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <div class="grid-row grid-gap-0">
            <legend class="usa-legend usa-legend--medium">Requestor</legend>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="reqFirstName" class="usa-label">First Name <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="reqFirstName" formControlName="reqFirstName" class="usa-input maxw-full" maxlength="35"/>
              <small class="define-text-secondary" *ngIf="(generateAPIFormGroup.get('reqFirstName').touched ||
                                                            generateAPIFormGroup.get('reqFirstName').dirty) && generateAPIFormGroup.get('reqFirstName').errors?.required">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> First Name is required
                <span *ngIf="generateAPIFormGroup.get('reqFirstName').errors?.pattern">Special Characters and Number doesnt allow for First Name.</span>
              </small>
              <small class="define-text-secondary" *ngIf="(generateAPIFormGroup.get('reqFirstName').touched ||
                                                            generateAPIFormGroup.get('reqFirstName').dirty) &&
                                                            generateAPIFormGroup.get('reqFirstName').errors?.pattern">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Special Characters and Number doesnt allow for First Name.
              </small>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
              <label for="reqMiddleName" class="usa-label">M.I</label>
              <input type="text" id="reqMiddleName" formControlName="reqMiddleName" class="usa-input maxw-full" maxlength="1"/>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-10 desktop:grid-col-10">
              <label for="reqLastName" class="usa-label">Last Name <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="reqLastName" formControlName="reqLastName" class="usa-input maxw-full" maxlength="35"/>
              <small class="define-text-secondary" *ngIf="(generateAPIFormGroup.get('reqLastName').touched ||
                                                          generateAPIFormGroup.get('reqLastName').dirty) &&
                                                          generateAPIFormGroup.get('reqLastName').errors?.required">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Last Name is required.
              </small>
              <small class="define-text-secondary" *ngIf="(generateAPIFormGroup.get('reqLastName').touched ||
                                                          generateAPIFormGroup.get('reqLastName').dirty) &&
                                                          generateAPIFormGroup.get('reqLastName').errors?.pattern">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>  Special Characters and Number doesnt allow for Middle Name.
              </small>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="reqEmail" class="usa-label">Email <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="reqEmail" formControlName="reqEmail" class="usa-input maxw-full" maxlength="254"/>
              <small class="define-text-secondary" *ngIf="(generateAPIFormGroup.get('reqEmail').touched ||
                                                            generateAPIFormGroup.get('reqEmail').dirty) &&
                                                            generateAPIFormGroup.get('reqEmail').errors?.required">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Email is required.
            </small>

            <small class="define-text-secondary" *ngIf="(generateAPIFormGroup.get('reqEmail').touched ||
                                                          generateAPIFormGroup.get('reqEmail').dirty) &&
                                                          generateAPIFormGroup.get('reqEmail').errors?.pattern">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Please enter a valid email.
            </small>

            </div>
          </div>
        </div>
      </div>
      <div class="grid-row margin-top-4">
        <button type="button" class="usa-button" [disabled]="!generateAPIFormGroup.valid" (click)="onSubmit()">{{isOldOrganizationAPI === true ? 'Save' : 'Create'}}</button>
      </div>
    </fieldset>
  </form>
</div>
